<template>
  <router-view />
</template>

<style lang="scss">
::-webkit-scrollbar {
  background-color: #00558263;
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #005482;
  border-radius: 10px;
}
</style>
